import { FC } from "react";
import { get, first } from "lodash";
import { useSelector } from "react-redux";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { useAiSaasOutputContainer } from "..";
import SharesBuy from "@views/components/SharesBuy";
import ContentFrame from "@views/ContentFrame";

type AISaasItemContentProps = {
  thought: AISaasOutput.ThoughtType;
  index: number;
};
const AISaasItemContent: FC<AISaasItemContentProps> = ({ index, thought }) => {
  const { isShare } = useHomeUsePluginContainer();
  const { shareBuyClassName } = useAiSaasOutputContainer();
  const editorIdArr: any[] = useSelector((state: any) => state.fot.editorIdArr);
  const applicationTheme = useSelector((state: any) => state.editor.applicationTheme);
  const locusEditorId = useSelector((state: any) => state.fot.locusEditorId);

  const firstResulut = first(get(thought, "results"));

  if (firstResulut && firstResulut.type === "stock") {
    return (
      <div className={`${applicationTheme}`}>
        {editorIdArr.some(x => `saas${x.editorId}` === locusEditorId) ? (
          <div className={shareBuyClassName}>
            <SharesBuy filteredThoughts={[]} editorId={firstResulut.nodeId} />
          </div>
        ) : (
          <ContentFrame
            isShare={isShare}
            locus="saas"
            zone="editorMode"
            content={thought}
            editorId={thought.results[0].nodeId}
            select_thought={() => {}}
            add_angle={() => {}}
            add_like={() => {}}
            add_dislike={() => {}}
            ContentRetrieval={() => {}}
            enterQuery=""
            otherModes={["studioMode", "editorMode"]}
          />
        )}
      </div>
    );
  }
  return (
    <ContentFrame
      className={`ai-saas ${applicationTheme}`}
      id={index}
      isShare={isShare}
      locus="saas"
      zone="editorMode"
      content={thought}
      editorId={thought.results[0].nodeId}
      select_thought={() => {}}
      add_angle={() => {}}
      add_like={() => {}}
      add_dislike={() => {}}
      ContentRetrieval={() => {}}
      enterQuery=""
      otherModes={["studioMode", "editorMode"]}
    />
  );
};

export default AISaasItemContent;
